// Styles
import CompanyModelViewContainer from "./CompanyModelView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useBQMQ } from "context/BQMQ.context";

type Props = {};

export default function CompanyModelView({}: Props) {
    const location = useLocation();
    const { companies } = useBQMQ();

    const companyId = useMemo(() => {
        return new URLSearchParams(location.search).get("company_id");
    }, [location.search]);

    const company = useMemo(() => {
        if (!companyId) return null;
        return (
            companies.find(
                (c: BQMQDropdownCompany) => String(c.value) === companyId
            ) ?? null
        );
    }, [companyId, companies]);

    const redshiftId = company?.redshift_company_id ?? null;

    const filterString =
        redshiftId != null
            ? `HistoricSnapshot/company_id eq ${redshiftId}`
            : undefined;

    return (
        <CompanyModelViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="a5340d94-9569-4fa6-8b54-55e265a9aa13"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                    filterString={filterString}
                />
            </div>
        </CompanyModelViewContainer>
    );
}
